import { Box, Typography } from '@mui/material';
import { landingContent } from '../landing-content';
import { landingPalette } from '../landing-theme';
import { SectionShell } from './SectionShell';

/** Three-up metrics row bounded by hairlines. */
export function LandingMetrics() {
  const hairline = `1px solid ${landingPalette.line}`;

  return (
    <SectionShell
      aria-label={landingContent.sectionLabels.metrics}
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', sm: 'repeat(3, 1fr)' },
        borderTop: hairline,
        borderBottom: hairline,
      }}
    >
      {landingContent.metrics.map((metric, index) => (
        <Box
          key={metric.label}
          sx={{
            px: 3,
            py: 5,
            borderTop: { xs: index === 0 ? 'none' : hairline, sm: 'none' },
            borderLeft: { xs: 'none', sm: index === 0 ? 'none' : hairline },
          }}
        >
          <Typography
            component="strong"
            sx={{
              display: 'block',
              mb: 0.75,
              fontSize: 'clamp(2.6rem, 5vw, 4.8rem)',
              lineHeight: 1,
              letterSpacing: '-.05em',
              fontWeight: 700,
            }}
          >
            {metric.value}
          </Typography>
          <Typography sx={{ color: 'text.secondary' }}>{metric.label}</Typography>
        </Box>
      ))}
    </SectionShell>
  );
}
